import Tabs from "./Tabs"
import TabsList from "./TabsList"
import TabsTrigger from "./TabsTrigger"
import TabsContent from "./TabsContent"
import TabsSeparator from "./TabsSeparator"
import TabsHeading from "./TabsHeading"

export type { TabsProps } from "./Tabs"
export type { TabsListProps } from "./TabsList"
export type { TabsTriggerProps } from "./TabsTrigger"
export type { TabsContentProps } from "./TabsContent"
export type { TabsSeparatorProps } from "./TabsSeparator"
export type { TabsHeadingProps } from "./TabsHeading"

export { useTabParam } from "./tabs.utils"

export default Object.assign(Tabs, {
  Content: TabsContent,
  Heading: TabsHeading,
  List: TabsList,
  Separator: TabsSeparator,
  Trigger: TabsTrigger,
})
